import './cravecul/style';
import FormStructure from './cravecul/form_structure';

export default FormStructure;